import React from "react";
import Button from '@material-ui/core/Button';
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Table from '../Common/table';
import API from "../../actions";
import NewClinicUserForm from "./NewClinicUserForm";
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined';
import update from "immutability-helper";
import _ from "lodash";

class ClinicUsers extends React.Component {
    constructor(props) {
        super(props)
        this.handleSwitchChange = this.handleSwitchChange.bind(this)
    }
    state = {
        users: [],
        dialogOpen: false,
        sortColumn: { path: "nameFirst", order: "asc" }
    }

    columns = [
        { path: "nameFirst", label: "Fornavn", type: "alpha" },
        { path: "nameLast", label: "Efternavn", type: "alpha" },
        { path: "email", label: "Email", type: "alpha" },
        { path: "isAvailable", label: "Jeg kan tage nye klienter", type: "switch" },
        { path: "phone", label: "Mobil", type: "alpha" },
    ];

    onSort = () => {

    }

    componentDidMount() {
        this.getCompanyUsers();
    }
    async getCompanyUsers() {
        try {
            const users = await API.getCompanyTherapists('nameFirst', 'asc');
            this.setState({ users });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleSort = sortColumn => {
        this.setState({ sortColumn });
    };
    handleClickOpen = () => {
        this.setState({ dialogOpen: true });
    };

    handleClose = () => {
        this.setState({ dialogOpen: false });
        this.getCompanyUsers();
    };

    async handleSwitchChange(event,therapistId){
        let status = event.target.checked;
        let therapist = await API.setTherapistAvailable(therapistId, status);
        let data = this.state.users;
        
        if(therapist)
        {
            let therapistIndex = data.findIndex(function(c) { 
                return c.id == therapistId; 
            });

            let updatedTherapist = update(data[therapistIndex], {isAvailable: {$set: therapist.isAvailable}}); 
            
            let newData = update(data, {
                $splice: [[therapistIndex, 1, updatedTherapist]]
            });
            this.setState({users: newData});
        }
        //this.getCompanyUsers();
    };

    render() {
        const { users, sortColumn, dialogOpen } = this.state;
        let sortedUsers = [];
        if(sortColumn.path === "isAvailable"){
            sortedUsers = _.orderBy(
                users,
                "isAvailable",
                [sortColumn.order]
            );
        }else{
            sortedUsers = _.orderBy(
                users,
                [user => (user[sortColumn.path] || '').toLowerCase()],
                [sortColumn.order]
            )
        }
        return (
            <Grid container component="main">
                <CssBaseline />
                {/* <Grid container>
                    <Grid item xs={6}>
                        <h3>Brugerliste</h3>
                    </Grid>
                    <Grid item xs={6} align="right">
                        <Button
                            variant="contained"
                            color="primary"
                            className="btn-darkgray"
                            startIcon={<AddCircleOutlinedIcon />}
                            onClick={this.handleClickOpen}>
                            Opret bruger
                        </Button>
                    </Grid>
                </Grid> */}
                <div className="box rounded shadown">
                    <div className="table-responsive">
                        <Table
                            columns={this.columns}
                            onSort={this.handleSort}
                            sortColumn={sortColumn}
                            data={sortedUsers}
                            handleSwitchChange = {this.handleSwitchChange}
                        />
                    </div>
                </div>
                <NewClinicUserForm dialogOpen={dialogOpen} onClose={this.handleClose} />

            </Grid>
        );
    }
}

export default ClinicUsers;